import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

export default function StoreLocatorListIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 20 20" {...props} fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.69989 4.99995C1.69989 4.28198 2.28192 3.69995 2.99989 3.69995H16.9999C17.7179 3.69995 18.2999 4.28198 18.2999 4.99995V15C18.2999 15.7179 17.7179 16.3 16.9999 16.3H2.99989C2.28192 16.3 1.69989 15.7179 1.69989 15V4.99995ZM4.29989 4.99995H2.99989V6.29995V13.7V15H4.29989H15.6999H16.9999V13.7V6.29995V4.99995H15.6999H4.29989Z"
        fill="#1E1E1E"
      />
      <path d="M6 10L14 10" stroke="#1E1E1E" strokeLinecap="round" />
      <path d="M6 12L9 12" stroke="#1E1E1E" strokeLinecap="round" />
      <path d="M11 12L14 12" stroke="#1E1E1E" strokeLinecap="round" />
      <path d="M6 8L14 8" stroke="#1E1E1E" strokeLinecap="round" />
    </SvgIcon>
  );
}
